import { createContext, useContext, useMemo } from 'react'

import { Space, Role } from '@tribeplatform/gql-client/types'

import { useI18n } from '../i18n/index.js'

import { getTranslatedRoleName } from './roles.js'

export type UserImportContextProps = {
  defaultSpaces: Space[]
  hasInviteDefaultsPermission: boolean
  loading: boolean
  spaces: Space[]
  roles: Role[]
  defaultRole: Role
}
export const UserImportContext = createContext<
  UserImportContextProps | undefined
>(undefined)

export const useUserImportContext = () => {
  const intl = useI18n()
  const context = useContext(UserImportContext)
  return useMemo(
    () => ({
      ...context,
      defaultRole: {
        ...context?.defaultRole,
        name: getTranslatedRoleName(intl, context?.defaultRole?.name),
      },
      roles: context?.roles.map(role => ({
        ...role,
        name: getTranslatedRoleName(intl, role.name),
      })),
    }),
    [context, intl],
  )
}
